import { updateObject, } from '../../utils/utility';

const initialState = {
    pageNumber: 0,
    quoteViewList: [],
    totalElements: 0,
    totalPages: 0,
    companyList: [],
    regionList: [],
    countryList: [],
    legalEntityList: [],
    orderTypeList: [],
    ctResponsibleList: [],
    customerNameList: [],
    statusList: [],
    vendorList: []
}

const setIndirectCustomerCTInitialQuotes = (state = initialState, action) => {
    const { pageNumber, totalPages, totalElements, quoteViewList, statusList, vendorList, customerNameList, companyList, regionList, countryList, legalEntityList, orderTypeList, ctResponsibleList } = action.payload;
    return updateObject(state, {
            pageNumber,
            quoteViewList,
            totalElements,
            totalPages,
            companyList,
            regionList,
            countryList,
            legalEntityList,
            orderTypeList,
            ctResponsibleList,
            customerNameList,
            statusList,
            vendorList
        }
    );
};

const reducer = (state = initialState, action) => {
    if (action.type === "SET_INDIRECT_CUSTOMER_CT_INITIAL_QUOTES") {
        return setIndirectCustomerCTInitialQuotes(state, action);
    }
    return state;
}

export default reducer;